import { $api } from '@service/RequestService';
import { stringifyUrl } from 'query-string';
import { useQuery } from 'react-query';

import { realtorConstants, realtorModels } from '..';

export const useCompanyRealtorAutoSelect = (props: { flatId?: number } = {}) =>
  useQuery<realtorModels.ICompanyRealtorSuggestion>({
    queryKey: [realtorConstants.queryKeys.COMPANY_REALTOR_AUTO_SELECT, props],
    queryFn: async () => {
      const res = await $api.get(
        stringifyUrl({
          url: '/v1/company/realtor/auto-select',
          query: {
            flatId: props?.flatId
          }
        })
      );

      return res.data.data;
    },
    enabled: !!props?.flatId
  });
